<template>
  <div class="lives-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入关键词查找..."></Input>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.status"
                  clearable
                  filterable
                  placeholder="审核状态...">
            <Option value="0"
                    key="0">未审核</Option>
            <Option value="1"
                    key="1">通过</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.livestatus"
                  clearable
                  filterable
                  placeholder="直播状态...">
            <Option value="0"
                    key="0">暂停</Option>
            <Option value="1"
                    key="1">在播</Option>
            <Option value="2"
                    key="2">预告</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.typeid"
                  clearable
                  filterable
                  placeholder="直播类型...">
            <Option v-for="item in livetypeList"
                    :value="item.id"
                    :key="item.id">{{item.title}}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Drawer title="编辑"
            v-model="showModalStatus"
            width="50"
            scrollable
            :loading="loading"
            :mask-closable="false">
      <Form :model="editInfo"
            ref="editInfoValidate"
            :rules="editInfoValidate"
            action="javascript:void(0)">
        <List>
          <ListItem>
            <FormItem label="标题"
                      prop="title">
              <Input v-model="editInfo.title"
                     placeholder="标题"></Input>
            </FormItem>
          </ListItem>
          <ListItem>
            <FormItem label="类型"
                      prop="type_id">
              <Select v-model="editInfo.type_id"
                      clearable
                      filterable
                      placeholder="类型...">
                <Option v-for="item in livetypeList"
                        :value="item.id"
                        :key="item.id">{{item.title}}
                </Option>
              </Select>
            </FormItem>
          </ListItem>
          <ListItem>
            <FormItem label="描述"
                      prop="describe">
              <Input type="textarea"
                     v-model="editInfo.describe"
                     placeholder="描述..."
                     :autosize="{minRows:4,maxRows:8}"></Input>
            </FormItem>
          </ListItem>
          <ListItem>
            <FormItem label="封面图"
                      prop="thumb">
              <upload-thumb v-model="editInfo.thumb"
                            ref="uploadthumb"
                            :defaultList="thumblist"
                            :autoCropWidth="670"
                            :autoCropHeight="332"
                            :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:670*332,大小不超过2M'"></upload-thumb>
            </FormItem>
          </ListItem>
          <ListItem>
            <FormItem label="房间公告"
                      prop="notice">
              <Input type="textarea"
                     v-model="editInfo.notice"
                     placeholder="房间公告..."
                     :autosize="{minRows:4,maxRows:8}"></Input>
            </FormItem>
          </ListItem>
          <ListItem>
            <FormItem label="开始时间"
                      prop="open_room">
              <DatePicker v-model="editInfo.open_room"
                          format="yyyy-MM-dd HH:mm:ss"
                          placeholder="开始时间"
                          style="width: 200px"
                          @on-change="changeDateOne"></DatePicker>
            </FormItem>
          </ListItem>
          <ListItem>
            <FormItem label="结束时间"
                      prop="close_room">
              <DatePicker v-model="editInfo.close_room"
                          format="yyyy-MM-dd HH:mm:ss"
                          placeholder="结束时间"
                          style="width: 200px"
                          @on-change="changeDateTwo"></DatePicker>
            </FormItem>
          </ListItem>

          <ListItem>
            <FormItem label="是否推荐"
                      prop="pos_flag">
              <RadioGroup v-model="editInfo.pos_flag">
                <Radio :label="0"
                       border>否</Radio>
                <Radio :label="1"
                       border>是</Radio>
              </RadioGroup>
            </FormItem>
          </ListItem>
          <ListItem>
            <FormItem label="排序"
                      prop="sort">
              <Input v-model="editInfo.sort"
                     placeholder="排序"></Input>
            </FormItem>
          </ListItem>
          <ListItem>
            <div class="demo-drawer-footer">
              <Button type="primary"
                      @click="editLiveRoom('editInfoValidate')">提交</Button>
            </div>
          </ListItem>

        </List>

      </Form>
    </Drawer>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";

export default {
  name: "live-room-list",
  data () {
    const validateOpenRoom = (rule, value, callback) => {
      if (this.editInfo.open_room === '' || this.editInfo.open_room == null) {
        callback(new Error('请选择房间开始时间'));
      } else {
        callback();
      }
    };
    const validateCloseRoom = (rule, value, callback) => {
      if (this.editInfo.close_room === '' || this.editInfo.close_room == null) {
        callback(new Error('请选择房间结束时间'));
      } else {
        callback();
      }
    };
    return {
      loading: true,
      dataloading: true,
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      title: '',
      formItem: {
        key: '',
        status: '',
        livestatus: '',
        typeid: '',
      },
      list: [
        {
          title: 'Id',
          key: 'id',
          fixed: 'left',
          width: 90
        },
        {
          title: '排序',
          minWidth: 90,
          key: 'name',
          render: (h, params) => {
            return h('div', [
              h('Input', {
                props: {
                  value: params.row.sort,
                },
                on: {
                  'on-enter': (value) => {
                    this.editSort(params.row.id, value.target.value)
                  }
                }
              }, '排序')
            ]);
          }
        },
        {
          title: '标题',
          key: 'title',
          minWidth: 200
        },
        {
          title: '用户名称',
          key: 'title',
          width: 150,
          render: (h, params) => {
            return h('div', [
              h('span', {}, params.row.userdata != null ? params.row.userdata.username : '')
            ]);
          }

        },
        {
          title: '类型',
          key: 'title',
          width: 100,
          render: (h, params) => {
            return h('div', [
              h('span', {}, params.row.type != null ? params.row.type.title : '')
            ]);
          }
        },
        {
          title: '时间',
          key: 'open_room',
          width: 180,
          render: (h, params) => {
            return h('div', [
              h('span', {}, params.row.open_room + '-' + params.row.close_room)
            ]);
          }
        },
        {
          title: '是否推荐',
          width: 90,
          render: (h, params) => {
            return h('div', [
              h('span', {}, params.row.pos_flag == 1 ? '是' : '否')
            ]);
          }
        },
        {
          title: "流地址",
          key: "registe_at",
          minWidth: 300,
          render: (h, params) => {
            return h("div", [
              h(
                "p",
                {
                  style: {
                    color: "#777"
                  }
                },
                "推流地址："
              ),
              h(
                "a",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                params.row.push_url
              ),
              h(
                "p",
                {
                  style: {
                    color: "#777"
                  }
                },
                "播放地址："
              ),
              h(
                "a",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                params.row.live_geturl
              ),
            ]);
          }
        },
        {
          title: '审核状态',
          width: 90,
          key: 'status',
          render: (h, params) => {
            return h('div', [
              h('i-switch', {
                props: {
                  value: params.row.status == 1 ? true : false  //控制开关的打开或关闭状态，官网文档属性是value
                },
                on: {
                  'on-change': (value) => {
                    this.changeStatus(params.row.id, value)
                  }
                }
              }, '开关')
            ]);
          }
        },
        {
          title: '直播状态',
          width: 90,
          key: 'status',
          render: (h, params) => {
            return h('div', [
              h('span', {}, params.row.live_status == 1 ? '在播' : (params.row.live_status == 0 ? '暂停' : '预告'))
            ]);
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 200,
          align: 'left',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                style: {
                  marginRight: '8px'
                },
                props: {
                  type: 'warning',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.callUlr(params.row.id)
                  }
                }
              }, '回放'),
              h('Button', {
                style: {
                  marginRight: '8px'
                },
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.detail(params.index, params.row.id)
                  }
                }
              }, '编辑'),
              h('Button', {
                style: {
                  marginRight: '8px'
                },
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.remove(params.index, params.row.id)
                  }
                }
              }, '删除')
            ]);
          }
        }
      ],
      tablelist: [],
      showModalStatus: false,
      editInfo: {
        title: '',
        type_id: 0,
        describe: '',
        notice: '',
        open_room: '',
        close_room: '',
        pos_flag: 0,
        sort: 0,
      },
      editInfoValidate: {
        title: [
          { required: true, message: '标题', trigger: 'blur' }
        ],
        describe: [
          { required: true, message: '描述', trigger: 'blur' }
        ],
        notice: [
          { required: true, message: '公告', trigger: 'blur' }
        ],
        open_room: [
          { required: true, validator: validateOpenRoom, trigger: 'change' }
        ],
        close_room: [
          { required: true, validator: validateCloseRoom, trigger: 'change' }
        ],
      },
      thumblist: [],
      livetypeList: [],
      isClear: false,
      params: {
        starttime: '',
        endtime: '',
        checkouttime: '',
      },
    }
  },
  // 组件
  components: {
    UploadThumb,
  },
  created: function () {
    this.$api.common.livetype({ size: 9999 }).then(res => {
      if (res.code == 200) {
        this.livetypeList = res.result.list;
      }
    });
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function () {
      this.$api.liveroom.list({ "page": this.pages.page, "size": this.pages.size }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
    },
    // 修改状态
    changeStatus: function (index, value) {
      this.$api.liveroom.check({ id: index, status: value }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
        }
      });
    },
    // 详情
    detail (index, id) {
      this.title = "编辑";
      this.editInfo = {
        title: '',
        type_id: 0,
        describe: '',
        notice: '',
        open_room: '',
        close_room: '',
        pos_flag: 0,
        sort: 0,
      };
      this.thumblist = [];
      this.$api.liveroom.detail({ id: id }).then(res => {
        this.showModalStatus = !this.showModalStatus;
        this.editInfo = res.result;
        //处理thumb
        if (this.editInfo.thumb != null && this.editInfo.thumb != "") {
          this.thumblist.push({
            name: this.editInfo.thumb,
            url: this.editInfo.thumb,
            status: "finished"
          });
        }


      });
    },
    changeDateOne (val) {
      this.editInfo.open_room = val;
    },
    changeDateTwo (val) {
      this.editInfo.close_room = val;
    },
    // 修改排序
    editSort: function (index, value) {
      this.$api.liveroom.sort({ id: index, sort: value }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.getTableList();
        }
      });
    },
    // 删除
    remove: function (index, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: '警告',
        content: '<p>此操作不可恢复，三思而后行...</p>',
        onOk: () => {
          this.$api.liveroom.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.tablelist.splice(index, 1);
            }
          });
        }
      });
    },
    editLiveRoom (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.$refs["uploadthumb"].uploadList.length > 0) {
            this.editInfo.thumb = this.$refs["uploadthumb"].uploadList[0].url;
          } else {
            this.editInfo.thumb = null;
          }
          this.$api.liveroom.edit(this.editInfo).then(res => {
            if (res.code == 200) {
              this.getTableList();
            }
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            this.showModalStatus = !this.showModalStatus;
          });
        } else {
          this.$Message.error('请检查输入的信息是否正确！');
          this.loading = false
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      })
    },
    //
    callUlr (id) {
      this.$router.push('/liveRoom/callback/' + id);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        status: this.formItem.status,
        livestatus: this.formItem.livestatus,
        typeid: this.formItem.typeid,
      };
      this.$api.liveroom.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.role_ids = res.result.role_ids;
          this.pages.total = res.result.total;
        }
      });
      return;
    },
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.getTableList();
    },

  }
}
</script>

<style scoped>
</style>